Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "createApiUrl", {
  enumerable: !0,
  get: function get() {
    return o.createApiUrl;
  }
}), Object.defineProperty(exports, "fetchFromApiUrl", {
  enumerable: !0,
  get: function get() {
    return o.fetchFromApiUrl;
  }
}), Object.defineProperty(exports, "fetchFromApi", {
  enumerable: !0,
  get: function get() {
    return o.fetchFromApi;
  }
}), Object.defineProperty(exports, "imageProxy", {
  enumerable: !0,
  get: function get() {
    return o.imageProxy;
  }
}), exports.default = void 0;

var e,
    t = function (e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (null != e) for (var r in e) {
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var o = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, r) : {};
      o.get || o.set ? Object.defineProperty(t, r, o) : t[r] = e[r];
    }
  }
  return t.default = e, t;
}(require("react")),
    r = require("./components/Card"),
    o = require("./utils");

function n(e) {
  return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function i() {
  return (i = Object.assign || function (e) {
    for (var t = arguments, r = 1; r < arguments.length; r++) {
      var o = t[r];

      for (var n in o) {
        Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function a(e) {
  for (var t = arguments, r = 1; r < arguments.length; r++) {
    var o = null != t[r] ? t[r] : {},
        n = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), n.forEach(function (t) {
      p(e, t, o[t]);
    });
  }

  return e;
}

function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function c(e, t) {
  return (c = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function u(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function p(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function f(t, r, o, n) {
  var i = arguments;
  e || (e = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var a = t && t.defaultProps,
      l = arguments.length - 3;
  if (r || 0 === l || (r = {
    children: void 0
  }), r && a) for (var c in a) {
    void 0 === r[c] && (r[c] = a[c]);
  } else r || (r = a || {});
  if (1 === l) r.children = n;else if (l > 1) {
    for (var u = new Array(l), p = 0; p < l; p++) {
      u[p] = i[p + 3];
    }

    r.children = u;
  }
  return {
    $$typeof: e,
    type: t,
    key: void 0 === o ? null : "" + o,
    ref: null,
    props: r,
    _owner: null
  };
}

var s = function s(e) {
  var o = e.url,
      n = e.size,
      i = e.title,
      a = e.description;
  return f(t.Fragment, {}, void 0, f(r.CardMedia, {
    image: e.image,
    video: e.video,
    url: o,
    cardSize: n,
    autoPlay: e.autoPlay,
    controls: e.controls,
    muted: e.muted,
    loop: e.loop,
    playsInline: e.playsInline
  }), f(r.CardContent, {
    className: "microlink_card__content",
    title: i,
    description: a,
    url: o,
    cardSize: n
  }));
},
    y = function (e) {
  function y() {
    var e,
        t,
        r,
        i = arguments;
    !function (e, t) {
      if (!(e instanceof y)) throw new TypeError("Cannot call a class as a function");
    }(this);

    for (var c = arguments.length, f = new Array(c), s = 0; s < c; s++) {
      f[s] = i[s];
    }

    return this, r = (e = l(y)).call.apply(e, [this].concat(f)), t = !r || "object" !== n(r) && "function" != typeof r ? u(this) : r, p(u(u(t)), "state", {
      loading: !0
    }), p(u(u(t)), "fetchData", function () {
      var e = t.props;
      (e.noFetch || !e.url ? Promise.resolve({}) : (0, o.fetchFromApi)(t.props)).then(function (e) {
        return t.mergeData(e.data);
      });
    }), p(u(u(t)), "mergeData", function (e) {
      var r = t.props.setData,
          n = [].concat(t.props.image),
          i = (0, o.isFunction)(r) ? r(e) : a({}, e, r),
          l = (0, o.someProp)(i, n),
          c = (0, o.getUrlPath)(l),
          u = l || {};
      t.setState({
        color: u.color,
        backgroundColor: u.background_color,
        title: i.title,
        description: i.description,
        url: i.url,
        loading: !1,
        video: i.video,
        image: c
      });
    }), t;
  }

  var d;
  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && c(e, t);
  }(y, t.Component), (d = [{
    key: "componentDidMount",
    value: function value() {
      this.fetchData();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.url !== this.props.url && this.fetchData();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.state,
          n = e.title,
          a = e.color,
          l = e.backgroundColor,
          c = e.url,
          u = e.loading,
          p = e.description,
          y = e.image,
          d = e.video,
          m = this.props,
          b = m.autoPlay,
          g = m.controls,
          v = m.loop,
          h = m.muted,
          O = m.playsInline,
          P = m.className,
          j = m.size,
          w = m.loading,
          _ = function (e, t) {
        if (null == e) return {};

        var r,
            o,
            n = function (e, t) {
          if (null == e) return {};
          var r,
              o,
              n = {},
              i = Object.keys(e);

          for (o = 0; o < i.length; o++) {
            t.indexOf(r = i[o]) >= 0 || (n[r] = e[r]);
          }

          return n;
        }(e, t);

        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);

          for (o = 0; o < i.length; o++) {
            t.indexOf(r = i[o]) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
          }
        }

        return n;
      }(m, ["autoPlay", "controls", "loop", "muted", "playsInline", "className", "size", "loading"]),
          S = (0, o.isNil)(w) ? u : w;

      return t.default.createElement(r.CardWrap, i({
        className: P ? "microlink_card ".concat(P) : "microlink_card",
        href: c,
        title: n,
        cardSize: j,
        color: a,
        backgroundColor: l,
        loading: S
      }, _), S ? f(r.CardEmpty, {
        cardSize: j
      }) : f(s, {
        title: n,
        description: p,
        url: c,
        image: y,
        video: d,
        autoPlay: b,
        controls: g,
        loop: v,
        muted: h,
        playsInline: O,
        size: j
      }));
    }
  }]) && function (e, t) {
    for (var r = 0; r < t.length; r++) {
      var o = t[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }(y.prototype, d), y;
}();

y.defaultProps = a({
  apiKey: void 0,
  autoPlay: !0,
  controls: !0,
  image: ["screenshot", "image", "logo"],
  loop: !0,
  muted: !0,
  playsInline: !0,
  reverse: !1,
  size: "normal"
}, o.defaultApiParameters), exports.default = y;